import API from './resources'

const actions = {
  async getAllForms({ commit, state }, payload) {
    try {
      const response = await API.getAllForms(
        state.page,
        state.size,
        state.product_id,
        payload.dataFilter ? payload.dataFilter : "",
        payload.token
      )
      commit('SET_FORM_LIST', response.data.content)
      commit('SET_FORM_PAGINATION', response.data)
     } catch (error) {
      return error
    }
  },
  async deleteFacebookForm({ commit }, payload) {
    const { data, token } = payload
    try {

      const response = await API.deleteFacebookForm(data, token)

      return response
    } catch (error) {
      return error
    }
  },
  async updateFacebook({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateFacebook(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postFacebook({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postFacebookResource(data, token)
      return response
    } catch (error) {
      return error
    }
  },

}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/facebook/actions.js